import React, { useState } from 'react';
import cs from 'classnames';
import styles from './index.module.less';
import V2FormInput from '../../../Form/V2FormInput/V2FormInput';
import V2FilterFooter from './V2FilterFooter';
import { useMethods } from '@lhb/hook';
import { isEqual, isNotEmpty } from '@lhb/func';
const V2FilterInput: React.FC<any> = ({
  name,
  headFilter,
  setHeadFilter,
  cacheHeadFilter,
  close,
  comType,
  extra,
  comProps,
}) => {
  const [targetValue, setTargetValue] = useState<any>(headFilter[name]);
  const methods = useMethods({
    confirm(newValue, force = false) {
      close();
      if (force) {
        setHeadFilter({
          ...headFilter,
          [name]: newValue
        });
      } else if (!isEqual(headFilter[name], newValue)) {
        if (!isNotEmpty(newValue) && !isNotEmpty(headFilter[name])) {
          return;
        }
        setHeadFilter({
          ...headFilter,
          [name]: newValue
        });
      }
    },
    handleSearch() {
      methods.confirm(targetValue);
    },
    clearFiltersAndClose() {
      if (isNotEmpty(targetValue?.value)) {
        methods.confirm(undefined, true);
      } else {
        methods.confirm(undefined);
      }
      setTargetValue(undefined);
    }
  });
  return (
    <div className={cs([styles.V2TableFilterCommon])}>
      <div>
        <V2FormInput
          placeholder='请输入'
          noStyle
          config={{
            defaultValue: targetValue?.value,
            onPressEnter: methods.handleSearch,
            maxLength: 50,
          }}
          onChange={e => {
            const newValue = {
              comType,
              value: e.target.value,
              extra
            };
            setTargetValue(newValue);
            cacheHeadFilter.current = {
              ...cacheHeadFilter.current,
              [name]: newValue
            };
          }}
          {...comProps}
        />
      </div>
      <V2FilterFooter
        handleSearch={methods.handleSearch}
        clearFiltersAndClose={methods.clearFiltersAndClose}
      />
    </div>
  );
};

export default V2FilterInput;
